import SelectionChip from '@/components/Select/SelectionChips/SelectionChip';
import { Box, Tooltip } from '@mui/material';
import { useMemo } from 'react';

interface IProps {
  items: string[];
  limitTags?: number;
}

const FilterGroupChip = ({ items, limitTags = 10 }: IProps) => {
  const displayedItems = useMemo(() => {
    if (!items?.length) return [];
    if (limitTags >= items?.length) return items;

    return [...items.slice(0, limitTags), '...', `+${items.length - limitTags}`];
  }, [items, limitTags]);

  if (!items?.length) return null;

  return (
    <Tooltip
      title={
        <>
          {displayedItems.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      }
    >
      <Box>
        <SelectionChip label={`+${items.length}`} />
      </Box>
    </Tooltip>
  );
};

export default FilterGroupChip;
